import 'moment/locale/cs';
